import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { PositionedUnderHeaderComponent } from "@hermes/header";
import { ExternalLibraryStateModule } from "@hermes/states/external-library";

import { CHAPTERS_COMPONENT } from "../../core";

import { LivestreamComponent } from "./livestream.component";

@NgModule({
    declarations: [LivestreamComponent],
    imports: [
        CommonModule,
        ExternalLibraryStateModule,
        PositionedUnderHeaderComponent,
    ],
    providers: [{ provide: CHAPTERS_COMPONENT, useValue: LivestreamComponent }],
})
export class LivestreamModule {}
